export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_AUTHENTICATED = 'SOCKET_AUTHENTICATED';
export const UPDATE_OT_SESSION = 'UPDATE_OT_SESSION';

export const LOGIN_USER = 'LOGIN_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const USER_PROFILE = 'USER_PROFILE';
export const USER_PLANS = 'USER_PLANS';
export const USER_TICKETS = 'USER_TICKETS';
export const USER_DEVICES = 'USER_DEVICES';



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js